import { useCallback, useState } from 'react';

export const ORDER_NOTIFICATION_PREFS_STORAGE_KEY = 'cp-order-notification-prefs';

export const DEFAULT_ORDER_NOTIFICATION_PREFS = {
  soundEnabled: true,
  browserNotificationsEnabled: true,
};

function readPrefs() {
  if (typeof window === 'undefined') return DEFAULT_ORDER_NOTIFICATION_PREFS;

  try {
    const stored = window.localStorage.getItem(ORDER_NOTIFICATION_PREFS_STORAGE_KEY);
    return stored ? { ...DEFAULT_ORDER_NOTIFICATION_PREFS, ...JSON.parse(stored) } : DEFAULT_ORDER_NOTIFICATION_PREFS;
  } catch (_error) {
    return DEFAULT_ORDER_NOTIFICATION_PREFS;
  }
}

export default function useOrderNotificationPrefs() {
  const [prefs, setPrefs] = useState(readPrefs);

  const updatePrefs = useCallback(partialPrefs => {
    setPrefs(currentPrefs => {
      const nextPrefs = { ...currentPrefs, ...partialPrefs };
      try {
        window.localStorage.setItem(ORDER_NOTIFICATION_PREFS_STORAGE_KEY, JSON.stringify(nextPrefs));
      } catch (_error) {
        // localStorage can be unavailable (private mode, storage disabled); prefs stay in-memory.
      }
      return nextPrefs;
    });
  }, []);

  return { prefs, updatePrefs };
}
